export default {
      setTourImage(state, payload){
        state.tourImage=payload;
      },
}